import React from 'react';
import MUIToolbar from '@mui/material/Toolbar';
export const Toolbar = props => {
  // const classes = useStyles();
  //const className = null//(props.disableTypography!=true) ? classes.defaultTypograpy : null;
  return /*#__PURE__*/React.createElement(MUIToolbar, props);
};
export default Toolbar;